














































import { Vue, Component, Prop, Model } from 'vue-property-decorator';

import CheckIcon from '@/components/icons/Check.vue';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';

@Component<CheckboxInline>({
  components: {
    CheckIcon,
    Typography
  }
})
export default class CheckboxInline extends Vue {
  @Model('input', { type: Boolean }) value!: boolean;

  @Prop(String) name!: string;
  @Prop(String) label!: string;
  @Prop({ default: false }) hasError?: boolean;
  @Prop({ default: false }) indeterminated?: boolean;
  @Prop({ default: false }) disabledBackground?: boolean;
  @Prop({ default: false }) enableEllipsis?: boolean;
  @Prop({ default: false }) componentToRender?: any;
  @Prop() option?: any;
}
